<template>
  <div style="background-color: white">
    <van-nav-bar title="数据统计" left-arrow  @click-left="onClickLeft"/>
      <div class="main">
        <div class="cen-box">
          <img v-if="data.alarmPic" :src="data.alarmPic" @error="errorImage" alt="" >
          <img v-else src="http://192.168.30.111:9000/alarmpic/dff9e994-70b2-4e6f-8faf-0f290ecdf61a" alt="" >
          <div class="datas">
              <div class="datas-item">告警类型 &nbsp;<span style="color: red">{{data.algName}}</span></div>
              <div class="datas-item">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间 &nbsp;<span style="color: #333333">{{data.alarmTime}}</span></div>
              <div class="datas-item">商户名称&nbsp; <span style="color: #333333">{{data.merchantName}}</span></div>
              <div class="datas-item">设备名称&nbsp; <span style="color: #333333">{{data.deviceName}}</span></div>
              <div class="datas-item">通道名称&nbsp; <span style="color: #333333">{{data.rtspName}}</span></div>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      data:{
        alarmPic:'',
        algName:'',
        merchantName:'',
        deviceName:'',
        rtspName:'',
        errorImage:'http://192.168.30.111:9000/alarmpic/dff9e994-70b2-4e6f-8faf-0f290ecdf61a'
      }
    }
  },
  async created() {
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.goBack)
  },
  mounted() {
    this.data = this.$route.query.data
    window.addEventListener('popstate', () => {
      this.goBack();
    })
  },
  methods: {
    errorImage(event){
      let img = event.target;
      img.src = this.errorImage;
      img.onerror = null
    },
    goBack() {
      this.$router.push({ path: 'field' })
    },
    onClickLeft(){


      this.$router.back()
    }
  }
}
</script>
<style lang="less" scoped>
.main{
  padding: 10px;
  background: #f7f8fa;
  height: 100%;
  min-height: 550px;
  .cen-box{
    padding: 10px;
    border-radius: 5px;
    background: white;
    img{
      width: 100%;
      height: 200px;
    }
    .datas{
      width: 100%;
      height: 180px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .datas-item{
        margin-top: 5px;
        letter-spacing: 2px;
        font-family: "微软雅黑 Light";
        font-size: 14px;
        font-weight: 600;
        color: #666666;
      }
    }
  }
}
</style>
